<template>
<div>
    <b-container class="px-0">

        <b-row class="justify-content-md-center">
            <b-col cols=12>
                <b-card no-body tag="h1" class="border-0 pt-3 pb-3 bg-transparent">{{pageTitle}}
                </b-card>
            </b-col>
        </b-row>

        <b-row class="justify-content-md-center">
            <b-col cols="12" md="6" xl="4" class="mb-4" v-for="d in colectii" :key="d.id">
                <b-card :img-src="d.image === false ? require('../assets/imgplacehold.png') : baseurl + d.image" img-alt="Biblioteca Județeană Arad" img-top tag="article" class="shadow p-0 mb-4 rounded bg-transparent" fluid>
                    <b-card-title title-tag="h3" v-html="d.nume_categorie"> </b-card-title>

                    <div class="d-flex justify-content-center">
                        <b-button squared variant="primary" class="px-4 my-2 btn-index-card">
                            <router-link :to="{ path: '/categoria/'+ d.id_categorie + '/' + d.slug}">Vezi articolele</router-link>
                        </b-button>
                    </div>
                </b-card>
            </b-col>
        </b-row>

    </b-container>
</div>
</template>

<script>
export default {

    data() {
        return {
            pageTitle: 'Articole',
            colectii: {},
            baseurl: 'https://app.bibliotecaarad.ro/backend/storage/',
        }
    },
    methods: {
        getColectii() {
            fetch('https://app.bibliotecaarad.ro/backend/api/meniu')
                .then(response => response.json())
                .then(data => this.colectii = data);

        }
    },
    created() {
        this.getColectii()
    }
}
</script>
